import styled from 'styled-components';
import { colors } from '../colors';
import Col from '../col';

interface cardProps {
	paymentInfo?: boolean;
	projectInfo?: boolean;
	orgDetail?: boolean;
	orgDetailInner?: boolean;
	tradeInfo?: boolean;
	productStatus?: boolean;
	projectDetails?: boolean;
	marginBottom?: string;
	padding?: string;
	documentCards?: boolean;
	organizationLabel?: boolean;
	projectIndividualCards?: boolean;
	projectIndividualSelectCard?: boolean;
}
const Card = styled.div<cardProps>`
	border: 1px solid #e1e7ec;
	box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.03);
	border-radius: 5px;
	width: 100%;
	background: ${colors.White};
	margin-bottom: ${({ marginBottom }) => marginBottom || '30px'};
	padding: ${({ padding }) => padding};
	${({ projectInfo }) =>
		projectInfo &&
		`box-shadow:none;
        border: 1px solid ${colors.GreyE1};
        box-sizing: border-box;
        border-radius: 2px;
        padding:24px 24px 12px;
        position: relative;
        line-height: 19px;
        color: ${colors.Grey58};
        white-space: normal;
        }
        p{
            color: ${colors.Black};
            margin:8px 0 12px;
        }
        ${Col}{
            @media screen and (max-width:767px){
                flex:0 0 50%!important;
            };
            @media screen and (max-width:640px){
                flex:0 0 100%!important;
            };
        }
    `};
	${({ paymentInfo }) =>
		paymentInfo &&
		`box-shadow:none;
        border: 0;
        box-sizing: border-box;
        border-radius: 0;
        padding:24px 24px 12px;
        position: relative;
        margin-bottom:0;
        label, p{
            font-size: 13px;
            line-height: 19px;
            color: ${colors.Grey58};
            white-space: normal;
            display: inline;
        }
        p{
            color: ${colors.Black};
            margin:8px 0 12px;
        }
        ${Col}{
            @media screen and (max-width:767px){
                flex:0 0 50%!important;
            };
            @media screen and (max-width:640px){
                flex:0 0 100%!important;
            };
        }
    `};
	${({ orgDetail }) =>
		orgDetail &&
		`box-shadow:none;
        border: 1px solid ${colors.GreyE1};
        box-sizing: border-box;
        border-radius: 2px;
        width:100%;
        padding:24px 24px 12px;
        position: relative;
        margin-bottom:0;
        label, p{
            font-size: 13px;
            color: ${colors.Grey58};
            white-space: normal;
            margin-bottom:0;
            width:100%;
        }
        p{
            color: ${colors.Black};
            margin: 8px 0 12px;
            line-height: 19px;
        }
        ${Col}{
            display:flex;
            flex:0 0 15%!important;
            flex-direction: column;
            :last-child{
                flex:0 0 35%!important;
                @media screen and (max-width:767px){
                    flex:0 0 100%!important;
                }
            };
            @media screen and (max-width:1224px){
                flex:0 0 50%!important;
            };
            @media screen and (max-width:767px){
                flex:0 0 100%!important;
            };
        }
    `};
	${({ orgDetailInner }) =>
		orgDetailInner &&
		`box-shadow:none;
        border: 1px solid #efefef;
        box-sizing: border-box;
        background: #f4f6f7;
        border-radius: 2px;
        width:100%;
        padding:24px 24px 24px;
        position: relative;
        margin-bottom:0;
        min-height:250px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        button {
            width:180px;
        }
        label, p{
            font-size: 15px;
            line-height: 19px;
            color: ${colors.Grey58};
            white-space: normal;
            margin-bottom:20px;
            min-width:160px;
        }
        p{
            color: ${colors.Black};
            margin:0 0 12px;
        }
        ${Col}{
            display:flex;
            flex:0 0 100%!important;
            @media screen and (max-width:767px){
                flex:0 0 100%!important;
            }
            @media screen and (max-width:640px){
                flex:0 0 100%!important;
            }
        }
    `};
	${({ tradeInfo }) =>
		tradeInfo &&
		`box-shadow:none;
        background: #f8fafb;
        border-radius: 2px;
        padding: 15px 24px 15px;
        position: relative;
        margin-bottom:0;
        label, p{
            font-size: 13px;
            line-height: 19px;
            color: ${colors.Grey58};
            white-space: normal;
        }
        p{
            color: ${colors.Black};
            margin: 0 0 0 30px;
        }
        ${Col}{
            flex: 0 0 100%!important;
            display: flex;
            @media screen and (max-width:767px){
                flex:0 0 50%!important;
            };
            @media screen and (max-width:640px){
                flex:0 0 100%!important;
            };
        }
    `};
	${({ productStatus }) =>
		productStatus &&
		`display: flex;
        align-items: center;
        flex-wrap:wrap;
        justify-content: space-between;
        background: #fff;
        border-radius: 2px;
        padding: 15px 12px 15px 24px;
        position: relative;
        margin-bottom:0;
        border: 1px solid rgb(225 231 236 / 49%);
        box-shadow: 0px 5px 14px rgba(0,0,0,0.05) !important;
        label, p{
            font-size: 17px;
            line-height: 23px;
            color: #434343;
            white-space: normal;
        }
        p{
            margin: 0 0 0 17px;
            min-width: 75px;
            border-radius: 20px;
            height: 36px;
            font-size:16px;
            padding: 7px 12px;
            text-align:center;
            
            &.organisation-label {
                background: rgb(85 168 254 / 16%);
                border: 1px solid #55a8fe;
                color: #55a8fe;
            }
            &.paid-label {
                background: rgb(30 152 62 / 19%);
                border: 1px solid #22ab50;
                color: #2a902a;
            }
            &.pending-label {
                background: #ffbc0038;
                border: 1px solid #FF9800;
                color: #b9730d;
            }
            &.expired-label {
                background: rgb(255 0 0 / 14%);
                border: 1px solid #ff6868;
                color: #ad2f2f;
            }
            &.index-label {
                background:rgb(255 26  255 / 16%);
                border: 1px solid #e600e6;
                color: #b300b3;
            }
        }
        .product-info-block {
            display: flex;
            align-items: center;
            .product-info-item {
                display: flex;
                align-items: center;
                margin-right:50px;
                &:last-child {
                    margin-right:0;
                }
            }
        }
    `};
	${({ projectDetails }) =>
		projectDetails &&
		`box-shadow:none;
        border: 1px solid ${colors.GreyE1};
        box-sizing: border-box;
        border-radius: 2px;
    `};
	${({ documentCards }) =>
		documentCards &&
		`position: relative;
        background: ${colors.BlueE9};
        padding:10px!important;
    `}
	${({ projectIndividualCards }) =>
		projectIndividualCards &&
		`display:flex;
        margin-bottom:16px;
        border: none;
        box-shadow: none;
        align-items: center;
        :last-child{
            margin-bottom:0; 
        }
        @media screen and (max-width: 640px) {
            margin-bottom:0;
            margin-right:16px;
            :last-child{
                margin-right:0; 
            }
        };
    `};
	${({ projectIndividualSelectCard }) =>
		projectIndividualSelectCard &&
		`width:100%;
        border: 1px solid ${colors.GreyE1};
        background: ${colors.BlueE9};
        padding:24px;
        margin-bottom:0!important;
        img{
            width: 100%;
            height: calc(100vh - 445px);
            margin-bottom: 15px;
            object-fit: contain;
            border: 1px solid ${colors.GreyC4};
            background: ${colors.White};
        }
    `}
`;

export default Card;
